import { useJurisdictionStore } from './use-jurisdiction';

export const useIsSgpEnabled = (isEventSgpEnabled: boolean) => {
    const isConfigSgpEnabled = useJurisdictionStore(
        state => state.jurisdictionSettings?.productConfig?.settings?.sgp_enabled
    );
    return isEventSgpEnabled && !!isConfigSgpEnabled;
};
